module.exports = __webpack_public_path__ + "img/bubinga-mask.a933af92.png";